import { render } from "./InventoryItemsPage.vue?vue&type=template&id=366f8d6b"
import script from "./InventoryItemsPage.vue?vue&type=script&lang=js"
export * from "./InventoryItemsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__